export const iconFontAwesomeChildhoodShapes = (
	<i className="fa-solid fa-shapes"></i>
);
